import { Sun, Moon } from 'lucide-react';
import { useState, useEffect } from 'react';

const THEME_KEY = 'titan.theme';

function readTheme() {
  try {
    const stored = localStorage.getItem(THEME_KEY);
    if (stored === 'light' || stored === 'dark') return stored;
    return window.matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark';
  } catch {
    return 'dark';
  }
}

/**
 * ThemeToggle — Sun/Moon button that flips [data-theme] on <html> and
 * persists to localStorage. Same mechanism as before the "Site Office"
 * restyle (ThemeScript already applies the value pre-paint, so there is
 * no flicker on mount) — only the button chrome changed.
 */
export default function ThemeToggle() {
  const [theme, setTheme] = useState(readTheme);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    try {
      localStorage.setItem(THEME_KEY, theme);
    } catch (_) {}
  }, [theme]);

  function toggle() {
    setTheme((t) => (t === 'dark' ? 'light' : 'dark'));
  }

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={theme === 'dark' ? 'Switch to light theme' : 'Switch to dark theme'}
      style={{
        display:        'flex',
        alignItems:     'center',
        justifyContent: 'center',
        width:          '38px',
        height:         '38px',
        background:     'transparent',
        border:         '1.5px solid var(--line)',
        color:          'var(--ink-soft)',
        cursor:         'pointer',
        transition:     'color 200ms ease, border-color 200ms ease',
        flexShrink:     0,
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.color       = 'var(--acc-ink)';
        e.currentTarget.style.borderColor = 'var(--acc)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.color       = 'var(--ink-soft)';
        e.currentTarget.style.borderColor = 'var(--line)';
      }}
    >
      {theme === 'dark'
        ? <Sun size={17} strokeWidth={2} aria-hidden="true" />
        : <Moon size={17} strokeWidth={2} aria-hidden="true" />
      }
    </button>
  );
}
